import { makeStyles } from 'tss-react/mui';

export const useStepperStyles = makeStyles()(() => ({
  stepperContainer: {
    backgroundColor: 'white',
    height: '4px',
    width: '100%',
    borderRadius: '2px',
  },
  stepperBar: {
    marginBottom: '24px',
    height: '4px',
    backgroundColor: '#38de80',
    borderRadius: '2px',
    transition: 'width 2s',
  },
}));
